import * as React from "react";
const SvgFiBrandsItunes = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-itunes_svg__a)">
      <path
        fill="#151A2D"
        d="M23.997 6.648c-.008-1.285-.048-2.629-.643-3.799-.73-1.434-2.129-2.414-3.701-2.697-.99-.178-2.014-.151-3.016-.151H7.365c-1.004 0-2.024-.027-3.016.151-1.578.284-2.97 1.26-3.701 2.697C.163 3.8.044 4.872.015 5.924L.003 16.491c0 1.049-.035 2.123.151 3.16.28 1.561 1.277 2.979 2.697 3.702 1.433.73 3.097.645 4.658.645h8.983c1.542 0 3.234.08 4.658-.645 1.423-.724 2.415-2.132 2.697-3.702.177-.984.151-1.995.151-2.991zm-3.129 2.956c-.034.157-.169.295-.289.392q-.321.26-.654.503l-4.198 3.05 1.603 4.935q.128.393.234.791c.051.193.1.541-.142.629-.178.065-.399-.033-.547-.129q-.347-.224-.68-.467l-4.198-3.05-4.198 3.05q-.334.242-.68.467c-.13.084-.304.171-.463.158a.28.28 0 0 1-.234-.17c-.062-.149-.033-.338.007-.489q.106-.4.234-.791l1.603-4.935-4.198-3.05a15 15 0 0 1-.654-.503c-.121-.095-.258-.236-.295-.39a.28.28 0 0 1 .089-.275c.123-.105.312-.136.468-.144q.413-.022.825-.022H9.69l1.604-4.935q.127-.393.276-.778c.056-.144.145-.317.281-.4a.28.28 0 0 1 .289 0c.138.084.225.255.281.4q.149.385.276.778l1.604 4.935h5.189q.412 0 .825.022c.155.008.346.04.468.144a.27.27 0 0 1 .085.274"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-itunes_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsItunes;
